import { useEffect, useState } from "react";
import { useDealer } from "../../../../../../../tools/api";
import { convertToJalaliWithTime, formatDate } from "../../../../../../../tools/tools";
import { NotFound } from "../../../../../../../sources/svg/svg";
import { Table } from "antd";

const Charge = ({ purchase }) => {
	const { queryDCPurchaseBySPPurchaseId } = useDealer();

	const [dcState, setDCState] = useState({
		listCharge: [],
		currentPage: 0, //state current page show Records
		totalRecord: 0, // state totalRecord
		isLoading: true,
	});

	useEffect(() => {
		const initial = async () => {
			try {
				//#region charge
				setDCState((dc) => ({ ...dc, isLoading: true }));
				const payloadCharge = {
					SPPurchaseId: purchase?.guD_PurchaseProductId,
					search: {
						sort: "",
						filter: "",
						entriesperpage: 10,
						page: dcState.currentPage === 0 ? 0 : dcState.currentPage - 1,
						totalrowcount: 0,
					},
				};
				const responseCharge = await queryDCPurchaseBySPPurchaseId(payloadCharge);
				if (responseCharge)
					setDCState((dc) => ({ ...dc, listCharge: responseCharge.Result, totalRecord: responseCharge?.searchconfigmodel?.totalrowcount }));

				setDCState((dc) => ({ ...dc, isLoading: false }));
				//#endregion charge
			} catch (error) {
				setDCState((dc) => ({ ...dc, isLoading: false }));
				console.log(error?.message);
			}
		};
		if (purchase) initial();
	}, [purchase, dcState?.currentPage]);

	return (
		<>
			<div className="holder-table" style={{ marginTop: "3rem" }}>
				<Table
					className="tbl-normal"
					loading={dcState?.isLoadingList}
					columns={[
						{
							title: "مبلغ شارژ",
							dataIndex: "chargeamount",
							key: "chargeamount",
							width: 150,
						},
						{
							title: "تاریخ خرید",
							dataIndex: "purchasedate",
							key: "purchasedate",
							width: 150,
						},
						{
							title: "درگاه خرید",
							dataIndex: "paidtype",
							key: "paidtype",
							width: 150,
						},
						{
							title: "کاربر",
							dataIndex: "username",
							key: "username",
							width: 150,
						},
						{
							title: "وضعیت درخواست",
							dataIndex: "state",
							key: "state",
							width: 150,
						},
					]}
					locale={{
						emptyText: (
							<>
								<NotFound text={"رکوردی یافت نشد."} />
							</>
						),
					}}
					scroll={{ y: "100%" }}
					pagination={{
						className: "page-pagination",
						// position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
						onChange: (page) => {
							setDCState((dc) => ({ ...dc, currentPage: page }));
						},
						pageSize: 10,
						align: "start",
						current: dcState?.currentPage === 0 ? 1 : dcState?.currentPage,
						total: dcState?.totalRecord,
						showSizeChanger: false,
					}}
					dataSource={dcState?.listCharge.map((item, key) => ({
						key: key,
						chargeamount: item?.chargamount,
						purchasedate: (
							<>
								{convertToJalaliWithTime(item?.purchasedate)} - {formatDate(new Date(item?.purchasedate))}
							</>
						),
						paidtype: item?.paidtype,
						username: item?.username || "-",
						state: item?.state,
					}))}
				/>
			</div>
		</>
	);
};

export default Charge;
